import { isValidAppearance } from './utils';
export var extractTag = function extractTag(jsonLd) {
  var tag = jsonLd.tag;
  if (tag) {
    if (typeof tag === 'string') {
      return {
        text: tag,
        appearance: 'default'
      };
    } else if (Array.isArray(tag)) {
      var tags = tag.map(extractTagItem).filter(function (item) {
        return !!item;
      });
      if (tags.length > 0) {
        return tags.shift();
      }
    } else {
      return extractTagItem(tag);
    }
  }
};
var extractTagItem = function extractTagItem(tag) {
  if (typeof tag === 'string') {
    return {
      text: tag,
      appearance: 'default'
    };
  } else if (tag['@type'] === 'Link') {
    if (tag.name) {
      return {
        text: tag.name,
        appearance: 'default'
      };
    }
  } else {
    if (tag.name) {
      var appearance = tag.appearance;
      return {
        text: tag.name,
        // Jira currently uses tag.appearance to set the lozenge color. Remove this
        // once we migrate them away from using this old spec.
        appearance: isValidAppearance(appearance) && appearance || 'default'
      };
    }
  }
};